export const HOTEL_PARAM = "hotelId";
export const PRICE_TOKEN_PARAM = "priceToken";
export const ROOM_ID_PARAM = "roomId";
export const BOARD_PARAM = "board";
export const BED_PARAM = "bed";
export const CANCELLATION_PARAM = "cancellation";
export const PACKAGE_ID_PARAM = "packageId";
export const SHOW_ON_MAP_PARAM = "showOnMap";
